import SubscriptionsSelector from '../SubscriptionsSelector'
import { systemRequirementsUrl } from '../../constants'
import moment from 'moment'

export default ({ t, i18n, idsProducts, cart, addToCart, setSubscription, subscription, language, softwareLinksMap }) => (
  <div className="content">
    <h4 className="is-size-4 m-b-md">{t('common:ids-page-subtitle')}</h4>
    <div className="m-b-md">
      <ul>
        <li>{t('common:ids-page-content-1')}</li>
        <li>{t('common:ids-page-content-2')}</li>
        {/*<li>{t('common:ids-page-content-3')}</li>*/}
        <li>{t('common:ids-page-content-4')}</li>
        <li>{t('common:ids-page-content-5')}</li>
      </ul>
    </div>
    <div className="m-b-md">{t('common:ids-page-content-6')}</div>
    <div className="m-b-md">
      <ul>
        <li>
          {t('common:ids-page-content-7', {
            version: softwareLinksMap['IDS'].name,
            date: moment(softwareLinksMap['IDS'].release_date).format('MM/DD/YYYY')
          })}
        </li>
      </ul>
    </div>
    <SubscriptionsSelector
      products={idsProducts}
      subscription={subscription}
      setSubscription={setSubscription}
      addToCart={addToCart}
      cart={cart}
      language={language}
      t={t} />
    <div className="m-b-md">
      {t('common:ids-page-content-8')}&nbsp;
      <a href={systemRequirementsUrl(i18n.language)}
        target="_blank">
        {t('common:click-here')}
      </a>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/IDSSoftware/index.js